export default __webpack_public_path__ + "static/media/EM0580.34I-22659_-15370_0.279634d7.jpg";